const sectionStyle = {
  marginBottom: 28,
};

const headingStyle = {
  fontSize: 14,
  fontWeight: 600,
  color: "#8ecfff",
  marginBottom: 8,
  textTransform: "uppercase" as const,
  letterSpacing: 1,
};

const paragraphStyle = {
  marginBottom: 12,
  lineHeight: 1.7,
  color: "#ccc",
};

const listStyle = {
  margin: 0,
  paddingLeft: 20,
  lineHeight: 1.7,
  color: "#ccc",
};

const pageWrapper = {
  maxWidth: 720,
  margin: "0 auto",
  padding: "40px 20px 60px",
};

const pageTitle = {
  fontSize: 28,
  fontWeight: 700,
  marginBottom: 8,
  color: "#f1f1f3",
};

const lastUpdated = {
  fontSize: 13,
  color: "#888",
  marginBottom: 32,
};

export const TermsOfService = () => (
  <div style={pageWrapper}>
    <h1 style={pageTitle}>Terms of Service</h1>
    <p style={lastUpdated}>Last updated: February 2026</p>

    <div style={sectionStyle}>
      <p style={paragraphStyle}>
        By accessing or using View Chat ("the Service"), you agree to be bound
        by these Terms of Service. If you do not agree, you may not use the
        Service.
      </p>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>1. Eligibility</h2>
      <p style={paragraphStyle}>
        You must be at least 13 years old to use this Service.
      </p>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>2. Your Account</h2>
      <ul style={listStyle}>
        <li>
          You are responsible for maintaining the confidentiality of your
          account credentials and for all activity under your account.
        </li>
        <li>
          You agree not to use the Service for any unlawful purpose or to
          violate any applicable laws.
        </li>
      </ul>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>3. Intellectual Property</h2>
      <ul style={listStyle}>
        <li>
          The Service and its original content, features, and functionality are
          owned by View Chat and are protected by applicable intellectual
          property laws.
        </li>
        <li>
          You may not reproduce, distribute, modify, or create derivative works
          of any part of the Service except for personal, non-commercial use.
        </li>
      </ul>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>4. Limitation of Liability</h2>
      <p style={paragraphStyle}>
        The Service is provided "as is" without warranties of any kind. In no
        event shall View Chat be liable for any indirect, incidental, or
        consequential damages arising from your use of the Service.
      </p>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>5. Termination</h2>
      <p style={paragraphStyle}>
        We may suspend or terminate your access at any time, with or without
        cause. Upon termination, your right to use the Service ceases
        immediately.
      </p>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>6. Changes to These Terms</h2>
      <p style={paragraphStyle}>
        We may update these Terms from time to time. Continued use of the
        Service after changes constitutes acceptance of the revised Terms.
      </p>
    </div>
  </div>
);

export const PrivacyPolicy = () => (
  <div style={pageWrapper}>
    <h1 style={pageTitle}>Privacy Policy</h1>
    <p style={lastUpdated}>Last updated: February 2026</p>

    <div style={sectionStyle}>
      <p style={paragraphStyle}>
        This Privacy Policy describes how View Chat collects, uses, and protects
        your personal information when you use the Service.
      </p>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>1. Information We Collect</h2>
      <ul style={listStyle}>
        <li>
          <strong>Account information:</strong>{" "}
          name, email address, and authentication credentials you provide when
          signing up.
        </li>
        <li>
          <strong>Usage data:</strong>{" "}
          information about how you interact with the Service, including pages
          visited and features used.
        </li>
        <li>
          <strong>Conversation data:</strong>{" "}
          messages and metadata sent to the Service through the API by your
          integrations.
        </li>
      </ul>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>2. How We Use Your Information</h2>
      <ul style={listStyle}>
        <li>To provide and maintain the Service.</li>
        <li>To communicate with you about your account or the Service.</li>
        <li>To improve and develop new features.</li>
      </ul>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>3. Data Security</h2>
      <p style={paragraphStyle}>
        We take reasonable measures to protect your personal information from
        unauthorized access, use, or disclosure. However, no method of
        transmission over the internet is completely secure.
      </p>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>4. Information Sharing</h2>
      <ul style={listStyle}>
        <li>We do not sell your personal information to third parties.</li>
        <li>
          We may share information with service providers who help us operate
          the Service, subject to confidentiality obligations.
        </li>
      </ul>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>5. Your Rights</h2>
      <p style={paragraphStyle}>
        You may request access to, correction of, or deletion of your personal
        data by contacting us. We will respond to such requests within a
        reasonable timeframe.
      </p>
    </div>

    <div style={sectionStyle}>
      <h2 style={headingStyle}>6. Changes to This Policy</h2>
      <p style={paragraphStyle}>
        We may update this Privacy Policy from time to time. Continued use of
        the Service after changes constitutes acceptance of the revised policy.
      </p>
    </div>
  </div>
);
